var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 81.5237L14.42 80.6676L43.3439 25.7859L43.405 25.2049L30.6547 1.25545C29.5865 -0.750745 26.5792 -0.243509 26.2286 2.00227L13.8086 81.5237Z",
    fill: "#FFC24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1692 80.8711L14.6318 79.9692L43.2526 25.6625L30.5342 1.61568C29.4772 -0.369499 26.793 0.136563 26.4461 2.35881L14.1692 80.8711Z",
    fill: "#FFA712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 43.3207L62.1935 33.5979L52.6973 15.4695C51.7958 13.7535 49.2788 13.7486 48.3869 15.4695L43.3135 25.1455V25.9696L52.7 43.3207Z",
    fill: "#F4BD62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5307 42.9155L61.7601 33.4631L52.5307 15.8887C51.6543 14.2204 49.5252 14.0456 48.658 15.7187L43.5577 25.5446L43.4052 26.0469L52.5307 42.9155Z",
    fill: "#FFA50E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 81.5235L14.0857 81.2449L15.0927 80.8356L52.1036 43.9624L52.5725 42.6859L43.3398 25.0923L13.8086 81.5235Z",
    fill: "#F6820C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8854 100.12L87.381 81.4391L77.8158 22.53C77.5166 20.6869 75.2554 19.9582 73.9362 21.2798L13.8086 81.5239L47.1121 100.118C49.2168 101.293 51.7801 101.294 53.8854 100.12Z",
    fill: "#FDE068"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0808 81.2824L77.5882 22.8205C77.2913 20.9914 75.4109 20.2345 74.1018 21.546L14.1799 81.4094L47.1176 99.8197C49.2064 100.986 51.7503 100.987 53.8395 99.8214L87.0808 81.2824Z",
    fill: "#FCCA3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8854 99.5697C51.7801 100.744 49.2168 100.743 47.1121 99.568L14.0768 81.2407L13.8086 81.524L47.1121 100.118C49.2168 101.294 51.7801 101.294 53.8854 100.12L87.381 81.4392L87.299 80.9346L53.8854 99.5697Z",
    fill: "#EEAB37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/Firebase.684fe3754f02eafc906945a6b8d54070.svg";
export { ForwardRef as ReactComponent };